/**
 *
 * Asynchronously loads the RunRulesModal component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
